import React from 'react';
import propTypes from 'prop-types';
import {
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    tableContainer: {
      backgroundColor: '#f5f5f5',
      border: '2px solid rgba(128,128,128,0.4)',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '5px', // Ancho de la barra de desplazamiento vertical
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888', // Color de la barra de desplazamiento vertical
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555', // Color de la barra de desplazamiento vertical hover
      },
    },
    tableRow: {
      borderTop: '2px solid black',
    },
    spacedCell: {
      paddingLeft: '45px',
    },
  }));
};

const BillTable = (props) => {
  const { rows, subTotal, prepago, isAdmin, isEmailPreview } = props;
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();

  const ccyFormat = (num) => {
    return `${num ? num.toFixed(2) : 0}`;
  };
  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table sx={{ minWidth: 570 }} aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell align="center" colSpan={isAdmin ? 4 : 3}>
              Facturación PRESTOBOTS
            </TableCell>
          </TableRow>
          <TableRow className={classes.tableRow}>
            <TableCell>Descripcion</TableCell>
            <TableCell align="right">Cantidad</TableCell>
            {isAdmin && <TableCell align="right">Valor unidad</TableCell>}
            <TableCell align="right">Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows && rows.length > 0
            ? rows.map((row) => (
                <>
                  <TableRow className={classes.tableRow} key={row.desc}>
                    <TableCell>{row.desc}</TableCell>
                    <TableCell align="right">{row.ctdad}</TableCell>
                    {isAdmin ? <TableCell align="right"> $ {ccyFormat(row.unit)}</TableCell> : null}
                    <TableCell align="right"> $ {ccyFormat(row.price)}</TableCell>
                  </TableRow>
                  {!isEmailPreview &&
                    row.detail?.length > 0 &&
                    row.detail.map((detailItem, index) => (
                      <TableRow key={`${row.displayName}-detalle-${index}`}>
                        <TableCell
                          size="small"
                          colSpan={isAdmin ? 4 : 3}
                          className={classes.spacedCell}
                        >
                          {detailItem.displayName}
                        </TableCell>
                      </TableRow>
                    ))}
                </>
              ))
            : null}
          {prepago ? (
            <>
              <TableRow className={classes.tableRow} style={{ backgroundColor: '#90EE90' }}>
                <TableCell colSpan={isAdmin ? 3 : 2}>PREPAGO MES SIGUIENTE</TableCell>
                <TableCell align="right"> $ {ccyFormat(prepago.totalPrepago || 0)}</TableCell>
              </TableRow>
              <TableRow className={classes.tableRow} style={{ backgroundColor: '#FFFFD0' }}>
                <TableCell colSpan={isAdmin ? 3 : 2}>SUB TOTAL</TableCell>
                <TableCell align="right">
                  {' '}
                  $ {ccyFormat((prepago.totalPrepago || 0) + subTotal)}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRow} style={{ backgroundColor: '#FFCCCC' }}>
                <TableCell colSpan={isAdmin ? 3 : 2}>
                  PREPAGO MES ANTERIOR{' '}
                  {!isEmailPreview && '(monto contemplado en el total de PREPAGO MES SIGUIENTE)'}
                </TableCell>
                <TableCell align="right"> - $ {ccyFormat(prepago.lastPrepaid || 0)}</TableCell>
              </TableRow>
            </>
          ) : null}
          <TableRow className={classes.tableRow} style={{ backgroundColor: '#BBDEFB' }}>
            <TableCell colSpan={isAdmin ? 3 : 2} style={{ fontWeight: 'bold' }}>
              TOTAL
            </TableCell>
            <TableCell align="right" style={{ fontWeight: 'bold' }}>
              {' '}
              {ccyFormat(subTotal + (prepago?.totalPrepago || 0) - (prepago?.lastPrepaid || 0))}
            </TableCell>
          </TableRow>
          <TableRow style={{ backgroundColor: '#BBDEFB', height: '20px' }}>
            <TableCell
              colSpan={4}
              align="right"
              style={{
                fontWeight: 'bold',
                padding: '2px 25px',
                lineHeight: '1',
                height: '20px',
              }}
            >
              Más IVA
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const Props = {
  rows: propTypes.array,
  subTotal: propTypes.number,
  prepago: propTypes.object,
  isAdmin: propTypes.bool,
  isEmailPreview: propTypes.bool,
};

BillTable.propTypes = Props;

export default BillTable;
